module.exports = __webpack_public_path__ + "static/media/leaf1_left.b54b5013.svg";